import { getStoredDismiss, getDismissKey, setStoredDismiss, DISMISS_DURATION_24_HRS, isTreatmentForTrial } from '@zillow/app-upsell-utils';

var DISMISS_DURATION_1_WEEK = 24 * 60 * 60 * 7 * 1000;
var DISMISS_THRESHOLD = 3;
var DISMISS_COUNT_KEY = 'ACQ_DISMISS_COUNT_122021';
var HOME_PAGE_UPSELL_ID = 'hops_main';
var PAGE_FRAME_UPSELL_ID = 'pfs_main';
var SEARCH_PAGE_SAVE_UPSELL_ID = 'sxp_save_search';
var SEARCH_PAGE_HOME_SAVE_UPSELL_ID = 'sxp_home_save';
var SEARCH_PAGE_MORE_FILTERS_ID = 'sxp_more_filters';
var HDP_EMAIL_UPSELL_ID = 'hdp_email';
var REG_LOGIN_PAGE_UPSELL_ID = 'reg_login_main';

function shouldShow(dismissed) {
  if (dismissed) {
    return Date.now() > dismissed;
  }

  return true;
}

function getStoredDismissTimestamp(abs) {
  var dismissKey = getDismissKey(abs);
  return getStoredDismiss(dismissKey);
}

function getDismissDuration(abs) {
  var duration = DISMISS_DURATION_24_HRS;

  if (isTreatmentForTrial({
    abs: abs,
    trial: 'ACQ_Banner_Suppression',
    treatment: 'Variant_3dismiss'
  })) {
    var count = getStoredDismiss(DISMISS_COUNT_KEY);
    count = Number(count) || 0;
    count++;

    if (count >= DISMISS_THRESHOLD) {
      duration = DISMISS_DURATION_1_WEEK;
    }

    setStoredDismiss(DISMISS_COUNT_KEY, count);
  }

  return duration;
}

var dismissStore = function dismissStore(props) {
  var abs = props.abs;
  return {
    shouldRender: function shouldRender(upsellId) {
      var timeStamp = getStoredDismissTimestamp();
      return shouldShow(timeStamp);
    },
    setDismiss: function setDismiss(upsellId, timestamp) {
      var dismissKey = getDismissKey(abs);
      var duration = getDismissDuration(abs);
      setStoredDismiss(dismissKey, timestamp + duration);
      return duration / DISMISS_DURATION_24_HRS;
    }
  };
};
var loadGlobalDismissStore = function loadGlobalDismissStore(props) {
  window.__Z__APP_UPSELL_DISMISS_STORE = window.__Z__APP_UPSELL_DISMISS_STORE || dismissStore(props);
};

var shouldRender = function shouldRender(upsellId, timeout) {
  if (timeout === void 0) {
    timeout = 500;
  }

  var start = Date.now();

  function waitForGlobalStore(resolve, reject) {
    if (window && window.__Z__APP_UPSELL_DISMISS_STORE) {
      var render = window.__Z__APP_UPSELL_DISMISS_STORE.shouldRender(upsellId);

      resolve(render);
    } else if (timeout && Date.now() - start >= timeout) {
      reject(new Error('TIMEOUT'));
    } else {
      setTimeout(waitForGlobalStore.bind(this, resolve, reject), 50);
    }
  }

  return new Promise(waitForGlobalStore);
};
var setDismiss = function setDismiss(upsellId, timestamp, timeout) {
  if (timeout === void 0) {
    timeout = 300;
  }

  var start = Date.now();

  function waitForGlobalStore(resolve, reject) {
    if (window && window.__Z__APP_UPSELL_DISMISS_STORE) {
      var days = window.__Z__APP_UPSELL_DISMISS_STORE.setDismiss(upsellId, timestamp);

      resolve({
        days: days
      });
    } else if (timeout && Date.now() - start >= timeout) {
      reject(new Error('TIMEOUT'));
    } else {
      setTimeout(waitForGlobalStore.bind(this, resolve, reject), 50);
    }
  }

  return new Promise(waitForGlobalStore);
};

export { HDP_EMAIL_UPSELL_ID, HOME_PAGE_UPSELL_ID, PAGE_FRAME_UPSELL_ID, REG_LOGIN_PAGE_UPSELL_ID, SEARCH_PAGE_HOME_SAVE_UPSELL_ID, SEARCH_PAGE_MORE_FILTERS_ID, SEARCH_PAGE_SAVE_UPSELL_ID, dismissStore, loadGlobalDismissStore, setDismiss, shouldRender };
